import moment from 'moment'

class Validations {
  // Método para validar um CPF, espera uma string sem máscara e retorna true caso seja válido ou false caso seja inválido
  static cpf(cpf) {
    if (cpf.length > 11) {
      return Validations.cnpj(cpf);
    }
    if (!cpf) return false;
    var i, add, rev;
    var cpff = cpf.replace(/[^\d]+/g, '');
    if (cpff == '') return false;
    if (
      cpff.length != 11 ||
      cpff == '00000000000' ||
      cpff == '11111111111' ||
      cpff == '22222222222' ||
      cpff == '33333333333' ||
      cpff == '44444444444' ||
      cpff == '55555555555' ||
      cpff == '66666666666' ||
      cpff == '77777777777' ||
      cpff == '88888888888' ||
      cpff == '99999999999'
    )
      return false;
    add = 0;
    for (i = 0; i < 9; i++) add += parseInt(cpff.charAt(i)) * (10 - i);
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(cpff.charAt(9))) return false;
    add = 0;
    for (i = 0; i < 10; i++) add += parseInt(cpff.charAt(i)) * (11 - i);
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11) rev = 0;
    if (rev != parseInt(cpff.charAt(10))) return false;
    return true;
  }

  // Método para validar um CNPJ, funciona da mesma forma que o de CPF praticamente
  static cnpj(cnpj) {
    cnpj = cnpj.replace(/[^\d]+/g, '');
    if (cnpj == '') return false;
    if (cnpj.length != 14) return false;
    if (
      cnpj == '00000000000000' ||
      cnpj == '11111111111111' ||
      cnpj == '22222222222222' ||
      cnpj == '33333333333333' ||
      cnpj == '44444444444444' ||
      cnpj == '55555555555555' ||
      cnpj == '66666666666666' ||
      cnpj == '77777777777777' ||
      cnpj == '88888888888888' ||
      cnpj == '99999999999999'
    )
      return false;
    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    let digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(0)) return false;
    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) pos = 9;
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado != digitos.charAt(1)) return false;
    return true;
  }

  // Método para validar o formato de uma data
  static data_YYYY_MM_DD_HH_mm_ss(dataHora) {
    let s, r;
    if (dataHora.length != 19) return false;
    try {
        s = moment(dataHora).format("YYYY-MM-DD HH:mm:ss");
        r =  (s != "Invalid date");
    }
    catch(e) {
        r = false;
    }
    return r;
  }

  // Método para validação de números/algarismos
  static textoSoNumerero(texto, tamanhoMinimo = 0, tamanhoMaximo = 250) {
    let re = new RegExp("^[0-9]{" + tamanhoMinimo.toString() + "," + tamanhoMaximo.toString() + "}$");
    return re.test(texto);
  }
}

export default Validations;
